import { render, staticRenderFns } from "./payPlan.vue?vue&type=template&id=5c89e839&scoped=true"
import script from "./payPlan.vue?vue&type=script&lang=js"
export * from "./payPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89e839",
  null
  
)

export default component.exports